export const baseUrl = "https://api.mytrumpf.com.qa.tru"; // "https://api.mytrumpf.com";
export const useMockData = true;

export interface EnvConfig {
    baseUrl: string;
    authIssuer: string;
    authClientId: string;
    useMockData: boolean;
    publicAPIVersion: string;
    publicAPIClientType: string;
}

const envConfigs: {
    [key: string]: EnvConfig;
} = {
    dev: {
        baseUrl: "https://api.mytrumpf.com.qa.tru",
        authIssuer: "https://identity-s.trumpf.com",
        authClientId: "1kffflasH4444COTiFmP8DDO9ywa",
        publicAPIVersion: "4.19",
        publicAPIClientType: "ServiceApp",
        useMockData: true
    },
    qa: {
        baseUrl: "https://api.mytrumpf.com.qa.tru",
        authIssuer: "https://identity-s.trumpf.com",
        authClientId: "1kffflasH4444COTiFmP8DDO9ywa",
        publicAPIVersion: "4.19",
        publicAPIClientType: "ServiceApp",
        useMockData: false
    },
    prod: {
        baseUrl: "https://api.mytrumpf.com",
        authIssuer: "https://identity.trumpf.com",
        authClientId: "1kffflasH4444COTiFmP8DDO9ywa",
        publicAPIVersion: "4.19",
        publicAPIClientType: "ServiceApp",
        useMockData: false
    }
};
let env: string = "prod";

/**
 * get config for a specific environment
 * @param environment any custom env string (optional - will use env set by setEnv otherwise)
 * @returns config object
 */
export const getEnvConfig = (environment?: string): EnvConfig => {
    return envConfigs[environment || env];
};

/**
 * set the current environment (used for getEnvConfig)
 * @param environment any custom env string
 */
export const setEnv = (environment: string) => {
    if (!envConfigs[environment]) {
        // eslint-disable-next-line no-console
        console.error(`Environment ${environment} not found`);
        return;
    }
    env = environment;
};
